import gsap from 'gsap';

export default function mobileMenu() {
	// Mobile menu
	var _body = document.body,
		mobileMenuToggle = document.getElementById('mobile-toggle'),
		menu_open = false,
		mobileMenu = document.getElementById('mobile-navigation'),
		mobileMenuLinks = mobileMenu.getElementsByTagName('a'),
		speed = 1;

	gsap.set(mobileMenuLinks, { y: 35, opacity: 0 });

	let menuReverse = () => {
		_body.classList.remove('of-hidden');
		_body.classList.remove('menu-open');
		mobileMenuToggle.classList.remove('menu-open');
		gsap.to(mobileMenu, {
			duration: speed,
			ease: 'power4.out',
			x: mobileMenu.offsetWidth,
		});
		gsap.to(mobileMenuLinks, {
			duration: speed,
			y: 35,
			opacity: 0,
			ease: 'expo.out',
		});
		menu_open = false;
	};

	document.addEventListener('click', function(ev) {
		if (ev.target.id != 'mobile-toggle') {
			return;
		}
		if (!menu_open) {
			_body.classList.add('of-hidden');
			_body.classList.add('menu-open');
			mobileMenuToggle.classList.add('menu-open');
			gsap.to(mobileMenu, {
				duration: speed,
				ease: 'power4.out',
				x: 0,
			});
			gsap.to(mobileMenuLinks, {
				duration: speed,
				y: 0,
				opacity: 1,
				ease: 'power4.out',
				stagger: 0.05,
				// delay: 0.05,
			});
			menu_open = true;
		} else {
			menuReverse();
		}
	});

	document.addEventListener('click', ev => {
		console.log(ev.target);
		if (!ev.target.classList.contains('mobile-link')) return;
		if (ev.target.parentNode.classList.contains('has-children')) {
			ev.target.parentNode.classList.toggle('open');
			ev.preventDefault();
			return;
		}
		menuReverse();
	});
}



// WEBPACK FOOTER //
// ./scripts/components/mobileMenu.js